import React from 'react'
import { Container } from 'semantic-ui-react'

export function Main (props) {
  return <Container {...props} style={{ paddingTop: 50 }} />
}
